import { CountUp } from 'countup.js';

window.onload = function() {

    function isDecimalNumber(input) {
        const decimalRegex = /^[-+]?\d+\.\d+$/;
        return decimalRegex.test(input);
    }

    const counter_els = [...document.querySelectorAll('.js-counter .content-stats-value')];
   
    const counter_el_options = {
        duration: 3,
        useGrouping: true,
        enableScrollSpy: true,
        useEasing: true,
    }

    if ( counter_els ) {
        counter_els.forEach((counter_el) => {
            const counter_el_data = counter_el.dataset.count;
            const counter_el_id = counter_el.id;
            const decimalPlaces = isDecimalNumber(counter_el_data) ? 2 : 0;
            
            
            const counter_el_instance = new CountUp(counter_el_id, counter_el_data, {
                ...counter_el_options,
                decimalPlaces,
            });

            counter_el_instance.start();
        });
    }
    
}